import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Chart from '../views/Chart.vue'
import Hotspot from '../views/Hotspot.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/chart', name: 'Chart', component: Chart },
  { path: '/chart/:codes', name: 'Chart', component: Chart, props: true },
  { path: '/hotspot', name: 'Hotspot', component: Hotspot },
  { path: '/hotspot/:codes', name: 'Hotspot', component: Hotspot, props: true },
  { path: '/', name: 'Home', component: Home },
  { path: '/:pageid', name: 'Home', component: Home, props: true },
]

const router = new VueRouter({
  routes
})

export default router
